var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4336 28H90.9636V85.43H86.4336V28Z",
    fill: "#FFA600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1335 85.42C107.474 85.42 119.914 72.57 119.914 56.71C119.914 40.85 107.474 28 92.1335 28C76.7935 28 64.3535 40.85 64.3535 56.71C64.3535 72.57 76.7935 85.42 92.1335 85.42Z",
    fill: "#FFA600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7234 85.42C102.063 85.42 114.503 72.57 114.503 56.71C114.503 40.85 102.063 28 86.7234 28C71.3834 28 58.9434 40.85 58.9434 56.71C58.9434 72.57 71.3834 85.42 86.7234 85.42Z",
    fill: "#FFDB2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7031 56.7096L61.873 43.8596C63.593 40.3096 66.0131 37.1596 68.9631 34.6196C71.9231 32.0796 75.3531 30.1996 79.0431 29.0996L86.7031 56.7096Z",
    fill: "#FFED7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7241 76.0696C97.0741 76.0696 105.454 67.3996 105.454 56.7096C105.454 46.0196 97.0641 37.3496 86.7241 37.3496C76.3841 37.3496 67.9941 46.0196 67.9941 56.7096C67.9941 67.3996 76.3841 76.0696 86.7241 76.0696Z",
    fill: "#FFBB00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4233 53.6601L96.8533 49.3101C96.8533 49.3101 100.983 63.1701 87.9732 66.9801L86.5032 67.1201C75.1732 66.0501 75.2832 53.7201 75.2832 53.7201L82.0433 55.0901C81.9133 52.1201 82.8332 49.2101 84.6332 46.8501L84.6932 46.8301C84.6932 46.8301 88.3933 48.6901 89.4233 53.6501V53.6601Z",
    fill: "#FFED7A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCoin);
export default __webpack_public_path__ + "static/media/card_coin.6503d09c9312b33e838d67bd5f4fe84c.svg";
export { ForwardRef as ReactComponent };